import { observer } from 'mobx-react';

import { AppLogo } from '../../../components/SVGIcons/AppLogo/AppLogo';
import type { WizardChildProps } from '../../../components/Wizard/types';
import { useMediaQuery } from '../../../hooks/useMediaQuery';

import { ForgotPasswordSuccessSection } from './components/ForgotPasswordSuccessSection';
import classes from './DirectRegLanding.module.scss';

const ForgotPasswordSuccessLanding = observer((props: WizardChildProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className={classes.directRegLandingContainer}>
      <div className={classes.directRegLanding}>
        <div className={classes.logoSection}>
          <AppLogo
            alwaysColorful
            withText
            textClassname={classes.logoText}
            textColor="#fff"
            width={isMobile ? 58 : 82}
          />
        </div>

        <div className={classes.bannerSection}>
          <ForgotPasswordSuccessSection {...props} />
        </div>
      </div>
    </div>
  );
});

export default ForgotPasswordSuccessLanding;
